module.exports = __webpack_public_path__ + "static/media/apple_store_download.016961ac.svg";